export default __webpack_public_path__ + "static/media/pdf.d246a2cf.svg";